var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.715,
    height: 79.932,
    viewBox: "0 0 79.715 79.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_44094",
    x: 0,
    y: 0,
    width: 79.715,
    height: 79.932,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-whatsapp",
    transform: "translate(14.364 11.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44093",
    "data-name": "Path 44093",
    d: "M4.868,53.662,8.291,41.167a24.122,24.122,0,1,1,20.9,12.077h-.01a24.094,24.094,0,0,1-11.527-2.936Z",
    transform: "translate(-3.597 -3.73)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.36, -11.36)",
    filter: "url(#Path_44094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44094-2",
    "data-name": "Path 44094",
    d: "M5,54.432a.635.635,0,0,1-.612-.8L7.743,41.389a24.754,24.754,0,1,1,9.967,9.733L5.164,54.411A.581.581,0,0,1,5,54.432Z",
    transform: "translate(10.63 7.5)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44095",
    "data-name": "Path 44095",
    d: "M29.463,5.27a24.122,24.122,0,0,1,0,48.244h-.01a24.094,24.094,0,0,1-11.527-2.936L5.139,53.932,8.561,41.438A24.125,24.125,0,0,1,29.463,5.27m0,48.244h0m0,0h0M29.463,4h0A25.4,25.4,0,0,0,7.2,41.607L3.913,53.6a1.27,1.27,0,0,0,1.549,1.564l12.307-3.227A25.394,25.394,0,1,0,29.463,4Z",
    transform: "translate(-3.868 -4)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44096",
    "data-name": "Path 44096",
    d: "M42.463,14.083A20.05,20.05,0,0,0,11.3,38.913l.478.758-2.026,7.4,7.588-1.99.733.434a20.01,20.01,0,0,0,10.2,2.794h.008A20.05,20.05,0,0,0,42.463,14.083Z",
    transform: "translate(-2.687 -2.862)",
    fill: "#40c351",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44097",
    "data-name": "Path 44097",
    d: "M20.594,16.27c-.451-1-.926-1.024-1.357-1.042-.352-.015-.753-.014-1.155-.014a2.215,2.215,0,0,0-1.607.755,6.755,6.755,0,0,0-2.11,5.026c0,2.965,2.16,5.831,2.461,6.233s4.17,6.681,10.3,9.1c5.091,2.007,6.127,1.608,7.233,1.508s3.566-1.457,4.068-2.865a5.047,5.047,0,0,0,.352-2.865c-.151-.252-.553-.4-1.155-.7s-3.566-1.76-4.119-1.96-.954-.3-1.357.3S30.587,31.7,30.235,32.1s-.7.454-1.306.151a16.5,16.5,0,0,1-4.847-2.991A18.158,18.158,0,0,1,20.73,25.09c-.352-.6-.038-.929.264-1.23.271-.271.6-.7.9-1.056a4.122,4.122,0,0,0,.6-1,1.108,1.108,0,0,0-.051-1.056C22.3,20.442,21.13,17.461,20.594,16.27Z",
    transform: "translate(-1.029 -0.967)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatapp);
export default __webpack_public_path__ + "static/media/whatapp.c00e28478c7c9ccdbd3422a1db1e9f69.svg";
export { ForwardRef as ReactComponent };